import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import { useQuery, useMutation } from 'react-apollo';
import { Button } from 'reactstrap';
import { GRAPH_ICON, graphDefaultValue, handleGraphqlError } from '../../../utils';
import AddDemoGraphics from './AddDemoGraphics';
import DemoGraphView from './DemoGraphView';
import Loading from '../../shared/loadingOverlay/Loading';
import { GET_DEMOGRAPHIC_DATA_QUERY } from '../../../graphql-client/queries';
import { CREATE_DEMO_GRAPH, LOADER_MUTATION, UPDATE_DEMO_GRAPH } from '../../../graphql-client/mutations';

function Demographics(props) {
  const {
    artistId, isEditDemoGraph, categories, updateIsEditDemoGraph, checkGraphHasData, isCurrentUserDeactive,
  } = props;
  const { addToast } = useToasts();
  const [mutationToCall, setMutationToCall] = useState(CREATE_DEMO_GRAPH);
  const [isDemoGraphEdit, setIsDemoGraphEdit] = useState();
  const [isDemoGraphSaved, setIsDemoGraphSaved] = useState(false);
  const {
    loading: getDemoGraphLoading, error, data: apiDemoData, refetch: getDemoDataRefetch,
  } = useQuery(
    GET_DEMOGRAPHIC_DATA_QUERY, {
      variables: { artistId },
    },
  );

  let graphApiData = apiDemoData && apiDemoData.getDemographic;

  const handleCancelGraph = (value) => {
    setIsDemoGraphEdit(value);
  };

  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
  });

  const [demoGraphCreate, { loading: mutationLoading }] = useMutation(mutationToCall, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },
    onCompleted(graphRes) {
      if (graphRes && graphRes.createDemographic) {
        graphApiData = graphRes.createDemographic;
      }
      addToast(apiDemoData.getDemographic.hasData ? graphRes.updateDemographic.message : graphRes.createDemographic.message, { appearance: 'success' });
      loaderMutate({ variables: { show: false } });
      updateIsEditDemoGraph(false);
      setIsDemoGraphEdit(false);
      handleCancelGraph(false);
      setIsDemoGraphSaved(true);
    },
  });

  const onSubmitCallBack = (graphData) => {
    graphData.artistId = artistId;
    demoGraphCreate({ variables: graphData });
    loaderMutate({ variables: { show: true } });
  };

  useEffect(() => {
    isEditDemoGraph && setIsDemoGraphEdit(isEditDemoGraph);
  }, [isEditDemoGraph]);

  useEffect(() => {
    if (artistId || isDemoGraphEdit) {
      getDemoDataRefetch({ artistId });
    }
  },
  [artistId, isDemoGraphEdit]);

  useEffect(() => {
    if (graphApiData) {
      setMutationToCall(graphApiData.hasData ? UPDATE_DEMO_GRAPH : CREATE_DEMO_GRAPH);
      checkGraphHasData({ hasData: graphApiData.hasData, lastUpdatedAt: graphApiData.hasData && graphApiData.data.updatedAt });
    }
  },
  [graphApiData]);

  if (getDemoGraphLoading || mutationLoading) {
    return <Loading active />;
  }
  if (error) {
    return addToast(handleGraphqlError(error), { appearance: 'error' });
  }

  const renderGraphView = () => {
    const graphData = graphApiData.hasData ? graphApiData.data : graphDefaultValue;
    return (!isDemoGraphEdit
      ? <DemoGraphView graphData={graphApiData.data} categoriesData={categories} />
      : (
        <AddDemoGraphics
          graphData={graphData}
          submitCallBack={onSubmitCallBack}
          isShowPreviousPage={graphApiData.hasData}
          cancelGraph={handleCancelGraph}
          updateIsEditDemoGraph={() => updateIsEditDemoGraph()}
        />
      ));
  };

  return (
    <>
      {
        (!mutationLoading && (isDemoGraphEdit || graphApiData.hasData))
          && renderGraphView()
      }

      {(!isDemoGraphEdit && !graphApiData.hasData && !mutationLoading && !isDemoGraphSaved)
          && (
            <div className="demographic-form-wrapper no-demographic-wrapper">
              <div className="no-demographic-section">
                <div className="no-demographic-content">
                  <img
                    src={GRAPH_ICON}
                    alt="Demographics"
                  />
                  <h2>Add data on Artists’ audience.</h2>
                  <Button
                    type="button"
                    className={`btn btn-add ${isCurrentUserDeactive ? 'pointer-none' : ''}`}
                    onClick={() => setIsDemoGraphEdit(true)}
                  >
                    + Add demographics
                  </Button>
                </div>
              </div>
            </div>
          )}
    </>
  );
}

Demographics.propTypes = {
  artistId: PropTypes.string.isRequired,
  isEditDemoGraph: PropTypes.bool,
  categories: PropTypes.array,
  updateIsEditDemoGraph: PropTypes.func.isRequired,
  checkGraphHasData: PropTypes.func.isRequired,
  isCurrentUserDeactive: PropTypes.bool,
};

Demographics.defaultProps = {
  categories: [],
  isEditDemoGraph: false,
  isCurrentUserDeactive: false,
};

export default Demographics;
